import React, { memo } from 'react';
import { Trans } from 'react-i18next';
import { ContactInteractionSms } from '@lgg/isomorphic/types/__generated__/graphql';
import { matchContactInteractionSmsExhaustive } from '@lgg/isomorphic/utils/match-contact-interaction';
import { TextItem } from 'src/components/pages/conversations/components/contact-interactions/items/text-item';

type SmsItemProps = {
  contactInteraction: ContactInteractionSms;
  conversationId: string;
};

export const SmsItem = memo<SmsItemProps>(({ contactInteraction, conversationId }) => {
  const buildManualInteractionTitle = () => {
    const transComponents = { strong: <strong /> };

    return matchContactInteractionSmsExhaustive(contactInteraction, {
      outbound: () => (
        <Trans
          i18nKey="conversations:contactInteractionBubble.sms.outbound"
          components={transComponents}
        />
      ),
      inboundWithParticipatingEntity: ({ participatingEntity }) => (
        <Trans
          i18nKey="conversations:contactInteractionBubble.sms.inboundWithParticipatingEntity"
          components={transComponents}
          values={{ participatingEntityLabel: participatingEntity.label }}
        />
      ),
      inboundWithoutParticipatingEntity: () => (
        <Trans
          i18nKey="conversations:contactInteractionBubble.sms.inboundWithoutParticipatingEntity"
          components={transComponents}
        />
      ),
    });
  };

  return (
    <TextItem
      testId="contact-interaction-sms"
      contactInteraction={contactInteraction}
      conversationId={conversationId}
      titleBuilder={buildManualInteractionTitle}
    />
  );
});
